import React, { CSSProperties } from "react";
import { FormattedMessage } from "react-intl";

import { RefreshButton } from "../refreshButton/RefreshButton";

interface Props {
  className: string;
  onRefreshClick: () => void;
  style?: CSSProperties;
}

export const LoadError = ({ onRefreshClick, className, style }: Props) => {
  return (
    <div className={className} style={style}>
      <FormattedMessage id={"loading_data_failure"} />
      <RefreshButton onClick={onRefreshClick} />
    </div>
  );
};
